import {
  ChangeDetectionStrategy,
  Component,
  Signal,
  viewChild,
} from '@angular/core';
import { AlfredClientComponent } from '@lyceo/alfred-client';
import { IonCard, IonCardContent, IonContent } from '@ionic/angular/standalone';
import { HeaderComponent } from '../shared/header/header.component';

@Component({
  selector: 'app-home-page',
  templateUrl: 'home-page.component.html',
  styleUrls: ['home-page.component.scss'],
  imports: [
    AlfredClientComponent,
    HeaderComponent,
    IonContent,
    IonCard,
    IonCardContent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomePageComponent {
  /**
   * The ion nav item that handles the navigation inside the
   * client component.
   */
  public readonly client: Signal<AlfredClientComponent> = viewChild.required(
    AlfredClientComponent,
  );

  /**
   * Save the current state of the step and navigate back
   * to the overview page
   */
  protected navigateToOverview(): void {
    this.client().nav().popToRoot();
  }
}
